import { ApiService } from './../api/api.service';

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { UtilService } from '../util/util.service';
import { IUTM } from '../../models/utm.model';
import { CookieService } from '../cookie/cookie.service';
import { VariablesService } from '../variables/variables.service';
import { EventsService } from '../events/events.service';
import { IUser } from '../../models';
import { ActivatedRoute } from '@angular/router';
import { IBasicInfo, IFundraiser } from '../../models/fundraiser.model';
import { environment } from 'projects/roj/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShareMessagesService {

  isLoggedIn;
  userdata: IUser;
  constructor(
    @Inject(DOCUMENT) private document: any,
    public storageService: StorageService,
    public utilService: UtilService,
    public cookieService: CookieService,
    public vars: VariablesService,
    public eventsService: EventsService,
    private actRout: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.utilService.isLoggedIn.subscribe({ next: res => this.isLoggedIn = res });
    this.vars.userData.subscribe({ next: res => this.userdata = res });
  }

  /**
 * Get The Whatsapp message
 * @param fundraiser Fundraiser Object
 */
  getFacebookUtm(fundraiser: IFundraiser) {
    return `?utm_source=internal&utm_medium=fbpageshare&utm_campaign=${fundraiser.custom_tag}` + this.getUtmContent();
  }

  /**
   * Get The Whatsapp message
   * @param fundraiser Fundraiser Object
   * @param basicInfo Basic Info of fundraiser
   * @param fStatus Fundraiser ENded Status
   */
  async getWhatsAppMessage(fundraiser: IFundraiser, basicInfo: IBasicInfo, fStatus: boolean, utms?, redirectToKetto?: boolean) {
    let pageName = 'fundraiser';
    if (this.vars.fundraiser.support_campaign) {
      pageName = 'supportfundraiser';
    }
    const page = this.vars.campaignType === 'stories' ? 'stories' : pageName;
    const kettoUrl = `${environment.APP.KETTO_DOMAIN_URL}/${page}/${fundraiser?.custom_tag}`;
    const campaignUrl = redirectToKetto ? kettoUrl : `${this.utilService.domain_details?.domain_url}/${page}/${fundraiser.custom_tag}`;
    const about_html = this.document.createElement('div');
    const utmData = {
      source: utms?.source || 'internal',
      medium: utms?.medium || 'whatsappShare',
      term: utms?.term || 'whatsappShare',
      campaign_name: fundraiser.custom_tag
    };
    about_html.innerHTML = this.vars.basicInfo.social;
    let about_text = about_html.textContent;
    about_text = about_text.replace(/\s\s+/g, ' ');
    if (about_text.length > 441) {
      about_text = `*${this.utilService.capitalizeFirstLatter(fundraiser.title)}* \n\n` + about_text.substr(0, 441).concat('...');
    }
    // If fundraiser ended then no contibute link
    let campainerName = '';

    if (fundraiser.campaigner && fundraiser.campaigner.full_name) {
      campainerName = fundraiser.campaigner.full_name.trim();
    } else {
      campainerName = 'Campaigner';
    }

    const long_url = this.getLinkWithUtmTags(campaignUrl, utmData);
    // const payload = {
    //   id: `rm-${fundraiser.id}`,
    //   long_url: long_url,
    //   utm_content: this.userdata?.id ? this.userdata?.id : ''
    // }
    // const shortURL = await this.apiService.getShortURL(payload);

    // Campaing Web URL
    let web_link = `\n\n*Read More.* ${long_url}\n\n`;

    if (!fStatus) {
      // Campaing Web URL
      web_link = `\n\n*Read More & Contribute Now.* ${long_url}\n\n`;
    }

    // `${host}/contribute/contribute.php${this.getLinkWithUtmTags('', utmData)}&fmd_id=${fundraiser.id}`;
    // Finally a cooked text ready for whatsapp
    const text_to_share = about_text + web_link;

    return encodeURIComponent(text_to_share);
  }
  /**Whatsapp share from sac thank you page */
  getWhatsAppMessage3(fundraiser, redirectToKetto?: boolean) {
    let pageName = 'fundraiser';
    if (this.vars.fundraiser.support_campaign) {
      pageName = 'supportfundraiser';
    }

    const kettoUrl = `${environment.APP.KETTO_DOMAIN_URL}/${pageName}/${fundraiser?.custom_tag}`;

    const campaignUrl = redirectToKetto ? kettoUrl : `${this.utilService.domain_details?.domain_url}/${pageName}/${fundraiser.custom_tag}`;
    const utmData = {
      source: 'internal',
      medium: 'whatsappShare',
      campaign_name: this.vars.fundraiser.custom_tag,
    };
    let beneficiaryRelation = '';
    if (fundraiser.beneficiaryrelation && fundraiser.beneficiaryrelation.info_1) {
      beneficiaryRelation = 'for my ' + fundraiser.beneficiaryrelation.info_1;
    }
    const text_to_share = `Hi,\n\n*I have started a fundraiser* ${beneficiaryRelation}`
      .concat(`\n\nI am sharing it with the *people closest* to me and *you* are amongst them 😇`)
      .concat(`\n\nIt is *essential that I receive my first donation, no matter how small it is*, to keep it going`)
      .concat(`\n\n${this.getLinkWithUtmTags(campaignUrl, utmData)}&utm_placement=sac_thank_you`)
      .concat(`\n\nThanks for your support in advance 🙏🏼`);
    return encodeURIComponent(text_to_share);
  }

  getUtmContent() {
    const data = this.storageService.getProperty('user', 'user');
    const userId = this.storageService.getProperty('userdata', 'id');
    const _ku = this.cookieService.getCookie('_ku');
    if (data) {
      return `&utm_content=${userId}`;
    } else if (_ku) {
      return `&utm_content=${_ku}`;
    } else {
      return '';
    }
  }
  /**Get the UTMS for the link */
  getLinkWithUtmTags(link: string, data: IUTM) {
    const prviousUtms = this.utilService.getUTMs();
    let tags = `${link.includes('?') ? '&' : '?'}utm_source=${prviousUtms?.utm_source||data?.source||'internal'}&utm_medium=${data.medium}${this.getUtmContent()}&shby=1`;
    if (data.campaign_name) {
      tags = tags.concat(`&utm_campaign=${data.campaign_name}`);
    }
    if (this.actRout.snapshot.queryParams['update_id']) {
      tags = tags.concat(`&update_id=${this.actRout.snapshot.queryParams['update_id']}`);
    }
    return link ? link + tags : tags;
  }

  /**Event fired after share */
  shareEvents(eventName, postion) {
    const systemEvent = {
      eventName: eventName,
      event_type: 'campaign',
      event_type_id: this.vars?.fundraiser?.id,
      info_1: 'position',
      info_2: postion || 3,
      info_3: this.vars.campaignType,
      page_name: this.vars.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
    const claverTap = {
      'Campaign Id': this.vars.fundraiser.id,
      'Page URL': this.utilService.domain_details?.full_url,
      'Campaign Title': this.vars.fundraiser.title,
      'Browser': this.utilService.detectBrowser(),
      'Campaign Type': this.utilService.getCampaignTypeFromId(this.vars.fundraiser.id),
      'Cause ID': this.vars.fundraiser.cause_id,
      'Device Type': this.utilService.isMobile() ? 'Mobile' : 'Desktop'
    };
    this.eventsService.claverTapPush(eventName, claverTap);
    const gtmData = {
      'event': 'social_shares',
      'event_category': eventName,
      'event_action': `social share ${eventName}`,
      'event_label': this.getEntity(), // campaigner or visitor or ngo
      'Campaign_custom_tag': this.vars.fundraiser.custom_tag || '',
      'Campaign_cause_id': this.vars.fundraiser.cause_id || '',
      'Campaign_Type': this.utilService.getCampaignTypeFromId(this.vars.fundraiser.id) || '',
      'Page_version': '',
      'position': postion || 3
    };
    this.eventsService.gtmPush(gtmData);
  }
  getEntity() {
    if (this.isLoggedIn) {
      this.utilService.getUserType(
        this.vars.fundraiser.creator_entity_details_id,
        this.vars.fundraiser.entity_details_id,
        this.userdata?.id
      );
    }
  }
}
